import './Layout.scss';

import { Body, type BodyProps } from 'src/components/base';

export function Layout(props: BodyProps) {
  return (
    <div className="layout__container">
      <Body {...props} />
    </div>
  );
}
